
        var result = require("!!../../../../node_modules/css-loader/index.js!./group.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/group/group.component.css
// module id = 1418
// module chunks = 0